var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Carousel, getTestId, GridContainer, GridRow, LeftArrowButtonIcon, RightArrowButtonIcon, Typography, useBreakpoint, checkIsPlatform } from '@airtel/air-design-system';
import { useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { BlogCardWidgetComponent as BlogCardWidget } from '../blog-card-widget/BlogCardWidget';
import { generateBreakpoints, getCarouselWidgetStyles } from './CarouselWidgetStyles';
import { CardSlide } from './components/card-slide';
import { CarouselImage } from './components/carousel-image';
import { CarouselNavigationButton } from './components/carousel-navigation-button';
import { NativeSlide } from './components/native-slide';
import { ImageVideoSlide } from './components/image-video-slide';
export var CarouselWidgetComponent = props => {
  var _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    _props$carouselType = props.carouselType,
    carouselType = _props$carouselType === void 0 ? 'IMAGE' : _props$carouselType,
    loop = props.loop,
    showNavigationCtas = props.showNavigationCtas,
    showIndicators = props.showIndicators,
    _props$breakPoints = props.breakPoints,
    _breakPoints = _props$breakPoints === void 0 ? {} : _props$breakPoints,
    theme = props.theme,
    alignment = props.alignment,
    id = props.id,
    onUserAction = props.onUserAction,
    onSlideChange = props.onSlideChange,
    onSlideVisibleHandler = props.onSlideVisibleHandler,
    _onSlideChangeHandler = props.onSlideChangeHandler,
    _props$onMountFireOnS = props.onMountFireOnSlideChange,
    onMountFireOnSlideChange = _props$onMountFireOnS === void 0 ? false : _props$onMountFireOnS,
    onLeftNavigationPress = props.onLeftNavigationPress,
    onRightNavigationPress = props.onRightNavigationPress,
    style = props.style,
    onPress = props.onPress,
    _props$showNavigation = props.showNavigationCounter,
    showNavigationCounter = _props$showNavigation === void 0 ? true : _props$showNavigation,
    onSlideVisible = props.onSlideVisible,
    imageStyle = props.imageStyle,
    _props$imageSlideProp = props.imageSlideProps,
    imageSlideProps = _props$imageSlideProp === void 0 ? {} : _props$imageSlideProp,
    _props$imageLoaderPro = props.imageLoaderProps,
    imageLoaderProps = _props$imageLoaderPro === void 0 ? {} : _props$imageLoaderPro,
    aspectRatio = props.aspectRatio,
    onItemVisibleMetaData = props.onItemVisibleMetaData,
    inViewTriggerOnce = props.inViewTriggerOnce,
    restProps = __rest(props, ["data", "carouselType", "loop", "showNavigationCtas", "showIndicators", "breakPoints", "theme", "alignment", "id", "onUserAction", "onSlideChange", "onSlideVisibleHandler", "onSlideChangeHandler", "onMountFireOnSlideChange", "onLeftNavigationPress", "onRightNavigationPress", "style", "onPress", "showNavigationCounter", "onSlideVisible", "imageStyle", "imageSlideProps", "imageLoaderProps", "aspectRatio", "onItemVisibleMetaData", "inViewTriggerOnce"]);
  var _props$heightConfig = props.heightConfig,
    heightConfig = _props$heightConfig === void 0 ? {
      desktop: 248,
      mobile: 208
    } : _props$heightConfig;
  if (carouselType === 'COMPONENT') {
    heightConfig = null;
  }
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen,
    breakpoint = _useBreakpoint.breakpoint;
  var breakPoints = generateBreakpoints(_breakPoints || {}) || {};
  var dataLength = data === null || data === void 0 ? void 0 : data.length;
  var _breakPoints$breakpoi = breakPoints[breakpoint],
    slidesToScroll = _breakPoints$breakpoi.slidesToScroll,
    slidesPerPage = _breakPoints$breakpoi.slidesPerPage,
    showNavigationCta = _breakPoints$breakpoi.showNavigationCta;
  var isNavigationCtasVisible = showNavigationCtas && dataLength !== slidesPerPage && showNavigationCta != false;
  var carouselWidgetStyles = getCarouselWidgetStyles(props, isLargeScreen, heightConfig);
  var carouselRef = useRef(null);
  var _useState = useState(0),
    activeSlide = _useState[0],
    setActiveSlide = _useState[1];
  var _useState2 = useState(loop),
    slideLoop = _useState2[0],
    setSlideLoop = _useState2[1];
  var visibliltyTrackerRef = useRef({});
  var childLengthWithoutFirstPage = dataLength - slidesPerPage;
  var childLength = Math.floor(childLengthWithoutFirstPage / slidesToScroll) + 1 || 0;
  var hasDeltaSlide = dataLength % slidesToScroll % slidesPerPage;
  if (hasDeltaSlide) childLength += 1;
  useEffect(() => {
    onMountFireOnSlideChange && onSlideChangeHandler(0);
  }, []);
  useEffect(() => {
    if (loop) {
      if (activeSlide === 0) {
        setSlideLoop(false);
      } else {
        setSlideLoop(true);
      }
    }
    var _ref = (breakPoints === null || breakPoints === void 0 ? void 0 : breakPoints[breakpoint]) || {},
      slidesPerPage = _ref.slidesPerPage;
    for (var index = activeSlide; index < activeSlide + slidesPerPage; index++) {
      if (!visibliltyTrackerRef.current[index]) {
        var currSlide = data === null || data === void 0 ? void 0 : data[index];
        visibliltyTrackerRef.current[index] = true;
        onSlideVisible && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onSlideVisible), currSlide));
      }
    }
  }, [activeSlide]);
  var onSlideChangeHandler = activeIndex => {
    setActiveSlide(activeIndex);
    if (loop) setSlideLoop(true);
    _onSlideChangeHandler === null || _onSlideChangeHandler === void 0 ? void 0 : _onSlideChangeHandler(activeIndex);
    onSlideChange && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onSlideChange), {
      index: activeIndex,
      item: data === null || data === void 0 ? void 0 : data[activeIndex]
    }));
  };
  var onPressCarousel = (item, index) => {
    if (item === null || item === void 0 ? void 0 : item.onPress) {
      onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, item.onPress), {
        item,
        index
      });
    } else if (onPress) {
      onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onPress), {
        item,
        index
      });
    }
  };
  var onInViewChange = data => {
    var inView = data === null || data === void 0 ? void 0 : data.inView;
    var item = data === null || data === void 0 ? void 0 : data.item;
    var index = data === null || data === void 0 ? void 0 : data.index;
    inView && onItemVisibleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onItemVisibleMetaData), Object.assign(Object.assign({
      index
    }, item), {
      timestamp: Date.now()
    })));
    inView && onSlideVisibleHandler && onSlideVisibleHandler(Object.assign(Object.assign({
      index
    }, item), {
      timestamp: Date.now()
    }));
  };
  var renderCarouselItem = (item, index) => {
    var _a, _b, _c, _d;
    switch (carouselType) {
      case 'IMAGE-VIDEO':
        return _jsx(ImageVideoSlide, {
          type: item === null || item === void 0 ? void 0 : item.type,
          videoProps: {
            videoId: item === null || item === void 0 ? void 0 : item.videoId
          },
          imageProps: Object.assign({
            style: [carouselWidgetStyles.imageSlide, imageStyle],
            source: {
              uri: isLargeScreen ? (_a = item.imageUrl) === null || _a === void 0 ? void 0 : _a.desktop : (_b = item === null || item === void 0 ? void 0 : item.imageUrl) === null || _b === void 0 ? void 0 : _b.mobile
            }
          }, isLargeScreen ? imageSlideProps === null || imageSlideProps === void 0 ? void 0 : imageSlideProps.desktop : imageSlideProps === null || imageSlideProps === void 0 ? void 0 : imageSlideProps.mobile),
          imageLoaderProps: imageLoaderProps,
          aspectRatio: aspectRatio,
          accessibilityProps: item === null || item === void 0 ? void 0 : item.accessibilityProps,
          style: [carouselWidgetStyles.imageSlide, imageStyle]
        });
      case 'IMAGE':
        return _jsx(CarouselImage, {
          imageProps: Object.assign({
            style: [carouselWidgetStyles.imageSlide, imageStyle],
            source: {
              uri: isLargeScreen ? (_c = item.imageUrl) === null || _c === void 0 ? void 0 : _c.desktop : (_d = item === null || item === void 0 ? void 0 : item.imageUrl) === null || _d === void 0 ? void 0 : _d.mobile
            }
          }, isLargeScreen ? imageSlideProps === null || imageSlideProps === void 0 ? void 0 : imageSlideProps.desktop : imageSlideProps === null || imageSlideProps === void 0 ? void 0 : imageSlideProps.mobile),
          imageLoaderProps: imageLoaderProps,
          aspectRatio: aspectRatio,
          accessibilityProps: item === null || item === void 0 ? void 0 : item.accessibilityProps
        });
      case 'CARD':
        return _jsx(CardSlide, {
          item: item,
          heightConfig: heightConfig,
          isLargeScreen: isLargeScreen,
          aspectRatio: props === null || props === void 0 ? void 0 : props.aspectRatio
        });
      case 'NATIVE':
        return _jsx(NativeSlide, {
          item: item,
          theme: theme,
          alignment: alignment,
          isLargeScreen: isLargeScreen,
          heightConfig: heightConfig,
          index: index,
          id: id,
          onUserAction: onUserAction
        });
      case 'COMPONENT':
        return item;
      case 'BLOG-CARD':
        return _jsx(BlogCardWidget, Object.assign({}, item, {
          onUserAction: onUserAction,
          heightConfig: heightConfig || (item === null || item === void 0 ? void 0 : item.heightConfig),
          titleAccessibilityProps: item === null || item === void 0 ? void 0 : item.titleAccessibilityProps,
          descriptionAccessibilityProps: item === null || item === void 0 ? void 0 : item.descriptionAccessibilityProps
        }));
      default:
        return _jsx(_Fragment, {});
    }
  };
  return _jsxs(View, Object.assign({
    style: [carouselWidgetStyles.container, style]
  }, restProps, getTestId(restProps.testID, 'carouselContainer'), {
    children: [_jsx(Carousel, Object.assign({}, props, {
      ref: carouselRef,
      data: data,
      renderItem: renderCarouselItem,
      onIndexChanged: onSlideChangeHandler,
      showIndicators: showIndicators && !showNavigationCtas,
      loop: slideLoop,
      onPress: onPressCarousel,
      inViewTriggerOnce: inViewTriggerOnce,
      onInViewChange: onInViewChange
    })), isNavigationCtasVisible && _jsx(GridContainer, Object.assign({
      style: carouselWidgetStyles.navigationCtaContainer,
      noMargin: true
    }, {
      children: _jsxs(GridRow, Object.assign({
        style: carouselWidgetStyles.navigationCtaInnerContainer,
        noMargin: true
      }, {
        children: [_jsx(CarouselNavigationButton, {
          Icon: LeftArrowButtonIcon,
          disabled: activeSlide === 0,
          theme: theme,
          onPress: () => {
            carouselRef.current.goToPrev();
            onLeftNavigationPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onLeftNavigationPress), {
              currentActiveIndex: activeSlide
            }));
          }
        }), showNavigationCounter ? _jsx(Typography, Object.assign({
          style: carouselWidgetStyles.navigationSlideCounter,
          type: "body-single-line-xs",
          text: activeSlide + 1 + "/" + childLength,
          theme: theme
        }, checkIsPlatform('web') && {
          'aria-hidden': true
        })) : _jsx(View, {
          style: {
            marginHorizontal: 92
          }
        }), _jsx(CarouselNavigationButton, {
          Icon: RightArrowButtonIcon,
          disabled: !slideLoop && activeSlide === childLength - 1,
          theme: theme,
          onPress: () => {
            carouselRef.current.goToNext();
            onRightNavigationPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onRightNavigationPress), {
              currentActiveIndex: activeSlide
            }));
          }
        })]
      }))
    }))]
  }));
};
CarouselWidgetComponent.genericRendererKey = 'AirCarouselWidget';